class ProductTabs {
    constructor(element) {
        this.element = element;
        this.tabs = element.querySelectorAll('.product-tabs__tab');
        this.panels = element.querySelectorAll('.product-tabs__panel');
        this.mainButton = element.querySelector('.product-tabs__button');
        this.sliders = {};

        this.init();
    }

    init() {
        this.setupTabs();
        this.initializeSliders();
        this.initAddToCart();
    }

    setupTabs() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', (e) => this.handleTabClick(e));
        });
    }

    handleTabClick(e) {
        const clickedTab = e.currentTarget;
        const targetId = clickedTab.dataset.tabTarget;

        this.tabs.forEach(tab => tab.classList.remove('product-tabs__tab--active'));
        this.panels.forEach(panel => panel.classList.remove('product-tabs__panel--active'));

        clickedTab.classList.add('product-tabs__tab--active');
        const targetPanel = document.getElementById(targetId);
        targetPanel.classList.add('product-tabs__panel--active');

        this.handleFilterClick(clickedTab)

        const sliderId = targetId.replace('tab-', '');
        if (this.sliders[sliderId]) {
            this.sliders[sliderId].refresh();
        }
    }

    handleFilterClick(tab) {
        const filter = tab.dataset.tabFilter;
        this.mainButton.href = `${this.mainButton.dataset.tabLink}?filter=${filter}`;
    }

    initializeSliders() {
        this.panels.forEach(panel => {
            const slider = panel.querySelector('.product-grid__slider');
            if (slider) {
                const sliderId = panel.id.replace('tab-', '');

                this.sliders[sliderId] = new Splide(slider, {
                    type: 'loop',
                    perPage: 4,
                    perMove: 1,
                    gap: 24,
                    pagination: false,
                    breakpoints: {
                        1024: {
                            perPage: 3,
                            gap: 20,
                        },
                        768: {
                            perPage: 2,
                            gap: 16,
                        },
                    },
                }).mount();
            }
        });
    }

    initAddToCart() {
        const atcButtons = this.element.querySelectorAll('.product-card__quick-add');
        atcButtons.forEach(btn => {
            btn.addEventListener('click', (e) => this.addToCart(e, btn));
        });
    }

    async addToCart(e, btn) {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const originalContent = btn.innerHTML;

        const payload = {
            items: [
                {
                    id: parseInt(variantId),
                    quantity: 1,
                },
            ],
        };

        if (btn.dataset.sellingPlanId) {
            payload.items[0]['selling_plan'] = btn.dataset.sellingPlanId;
        }
        if (
            btn.dataset['4weekPlanId'] !== null ||
            btn.dataset['4weekPlanId'] !== ''
        ) {
            payload.items[0]['selling_plan'] = btn.dataset['4weekPlanId'];
        }

        const settings = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        };

        try {
            const res = await fetch('/cart/add.js', settings);
            await res.json();

            if (res.status !== 200) {
                return;
            }

            if (typeof Shopify !== 'undefined' && Shopify.openCartDrawer) {
                Shopify.openCartDrawer();
            } else {
                window.location.href = '/cart';
            }
        } catch (err) {
            console.error(err);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const productTabsSections = document.querySelectorAll('.product-tabs');
    productTabsSections.forEach(section => new ProductTabs(section));
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector('.product-tabs');
        if (section) new ProductTabs(section);
    });
}